"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CoordinateBounds = _interopRequireDefault(require("../../geo/CoordinateBounds"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Point =
/** @class */
function () {
  function Point(coords) {
    if ((0, _utils.isEmpty)(coords)) {
      throw new Error('Invalid coordinates for Point');
    }

    var lon = coords[0],
        lat = coords[1];
    this.coordinates = {
      lat: lat,
      lon: lon
    };
  }

  Point.prototype.toArray = function (reversed) {
    if (reversed === void 0) {
      reversed = false;
    }

    var _a = this.coordinates,
        lat = _a.lat,
        lon = _a.lon;
    return reversed ? [lon, lat] : [lat, lon];
  };

  Point.prototype.bounds = function () {
    return _CoordinateBounds.default.fromPoints([this.coordinates]);
  };

  return Point;
}();

var _default = Point;
exports.default = _default;
module.exports = exports.default;